import { render, staticRenderFns } from "./Kakao.vue?vue&type=template&id=3508eea9&scoped=true"
import script from "./Kakao.vue?vue&type=script&lang=js"
export * from "./Kakao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508eea9",
  null
  
)

export default component.exports